import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Flag1LineIcon, Modal, message } from 'ui';
import { useCreateAbuseReport } from 'features/report';

export const useReportEvent = () => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: reportEvent } = useCreateAbuseReport();

  const confirm = useCallback(
    ({ event }: { event: { id: string; name: string } }) => {
      const handleReportEvent = async () => {
        await reportEvent(
          { contentObjectId: event.id },
          {
            onSuccess() {
              message.success('Event has been reported to admins of your organization.');
            },
          },
        );
      };

      modal.confirm({
        content: 'We will notify admins of your organization',
        icon: <Flag1LineIcon type="info" />,
        okText: 'Report',
        onOk: handleReportEvent,
        title: t('Are you sure you want to report {{name}}?', { name: event.name }),
      });
    },
    [modal, reportEvent, t],
  );

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
